module.exports = __webpack_public_path__ + "img/apple.36ba1def.svg";